<script lang="ts"></script>

<div class="w-100 text-center mt-1">
    <img class="logo mb-2" src="img/guglielmo_logo.png" alt="Guglielmo - Technology provider"/>
    <h1 class="mb-2">Dashboard di gestione delle manleve</h1>
    <p>Questa dashboard ti permette di consultare, creare, modificare e scaricare i template dei documenti e le manleve.</p>
</div>

